<template>
  <component
    :is="tagName"
    class="Heading"
    :class="[`Heading--${type}`, { 'Heading--visible': isVisible }]"
  >
    {{ heading }}
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';

defineOptions({
  name: 'HeadingBase',
});

interface Props {
  level: string;
  tag?: string;
  heading: string;
  type?: 'primary' | 'secondary' | 'tertiary' | 'quaternary';
  isVisible?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  tag: '',
  type: 'primary',
  isVisible: false,
});

const tagName = computed(() => {
  return props.tag || `h${props.level}`;
});
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_forward.scss' as *;

.Heading {
  &--primary,
  &--secondary,
  &--tertiary,
  &--quaternary {
    font-weight: bold;
    line-height: $service-line-height-mp;
    color: $color-gray-80;
  }

  &--primary {
    font-size: $service-font-size-fff;
  }

  &--secondary {
    font-size: $service-font-size-ff;
  }

  &--tertiary {
    font-size: $service-font-size-f;
  }
  &--quaternary {
    font-size: $service-font-size-mf;
  }

  &--visible {
    @include hidden;
  }

  @media (max-width: 426px) {
    &--tertiary {
      font-size: $service-font-size-p;
    }
    &--quaternary {
      font-size: $service-font-size-mp;
    }
  }
}
</style>
